/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Input } from '@angular/core';
import { TreeNode } from '@ali-hm/angular-tree-component';

/**
 * This is an extension of <code>tree-node-wrapper</code> component which allows DnD in heteragenous environment.
 */
@Component({
  standalone: false,
  selector: 'gh-tree-node-dnd-wrapper',
  templateUrl: 'tree-node-dnd-wrapper.component.html',
  host: {
    'class': 'node-wrapper',
    '[style.padding-left]': 'node.getNodePadding()',
  },
})
export class TreeNodeDndWrapperComponent {
  @Input() node: TreeNode;
  @Input() index: number;
  @Input() templates: any;
}
